var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c(
        "div",
        { staticClass: "image-wrapper" },
        [
          _c("progressive-img", {
            ref: "progressiveImage",
            staticClass: "no-highlight progressive-menu-img",
            attrs: { src: _vm.item.image, alt: _vm.item.description },
            on: { onLoad: _vm.loadImage }
          }),
          _vm._v(" "),
          _vm.showPrice
            ? _c(
                "div",
                { staticClass: "img-pricing-overlay" },
                [
                  _c("BaseButton", {
                    attrs: {
                      classNames: ["button--modifier", "menu-img-order-btn"],
                      title: "Order Now"
                    }
                  }),
                  _vm._v(" "),
                  _vm.showPrice
                    ? _c("p", { staticClass: "img-price" }, [
                        _c("span", { staticClass: "text-outline" }, [
                          _c("span", { staticClass: "dollar-sign" }, [
                            _vm._v("$")
                          ]),
                          _vm._v(_vm._s(_vm.getBundlePrice()))
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-110147fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-110147fc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/MenuItem/MenuItemImage.vue
// module id = null
// module chunks = 